import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery";

export const municipalitiesApi = createApi({
    reducerPath: "municipalitiesApi",
    baseQuery: axiosBaseQuery({
        baseUrl: `${process.env.REACT_APP_BACKEND_HOST}/api`,
    }),
    endpoints: (build) => ({
        getMunicipalities: build.query({
            query(params) {
                return {
                    url: "/municipalities",
                    method: "GET",
                    params: params
                };
            },
            providesTags: ["Municipalities"],
        }),
    }),
});

export const {
    useGetMunicipalitiesQuery,
    useLazyGetMunicipalitiesQuery
} = municipalitiesApi;